module.exports = __webpack_public_path__ + "img/key_cutter.e304e38f.png";